import { DEFAULT_ASSET_LOGO_SRC, DEFAULT_COMPANY_LOGO_SRC } from '@modules/profile/constants'
import {
  AnyResultProfile,
  GroupedResultProfile,
  isCompany,
  isCompanyAsset,
  isDelegate,
  isGroupedByCompanyItem,
} from '@modules/search/types'

export const getProfileImage = (profile: AnyResultProfile) => {
  if (isCompany(profile)) {
    return profile.latest.logo || profile.latest.profileData?.logo || DEFAULT_COMPANY_LOGO_SRC
  }

  if (isDelegate(profile)) {
    return profile.latest.profilePicture
  }

  return DEFAULT_ASSET_LOGO_SRC
}

export const getProfileTitle = (profile: AnyResultProfile) => {
  if (isCompany(profile)) {
    return profile.latest.name
  }

  if (isCompanyAsset(profile)) {
    return profile.latest.title
  }

  if (isDelegate(profile)) {
    return `${profile.latest.title}. ${profile.latest.firstName} ${profile.latest.lastName}`
  }

  return ''
}

export const getCompanyId = (profile: AnyResultProfile | GroupedResultProfile) => {
  if (isGroupedByCompanyItem(profile)) {
    return profile.company.id
  }

  if (isCompany(profile)) {
    return profile.latest.id || profile.id
  }

  return profile.latest?.companyId
}
